import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { ContractConfirmationFacade, ContractConfirmationReminderBase } from '@zero/shared/feature-contract-confirmation/base';
import { ButtonComponent, NotificationComponent } from '@zero/shared/ui-web-design-system';

@Component({
  selector: 'shared-micar-contracts-nudging',
  imports: [NotificationComponent, TranslocoPipe, ButtonComponent, AsyncPipe],
  templateUrl: './micar-contracts-nudging.component.html',
})
export class MicarContractsNudgingComponent extends ContractConfirmationReminderBase {
  public readonly facade = inject(ContractConfirmationFacade);
}
